module.exports = __webpack_public_path__ + "static/media/HK-PolyU.1ebc34c0.png";